export default __webpack_public_path__ + "public/assets/images/b92c50fb10a090d65cb377a3f68207ac.png";